import React from 'react';
import { Home, PenTool, HardHat } from 'lucide-react';
export function Audiences() {
  const audiences = [{
    title: 'Homeowners',
    copy: 'Get help choosing the right glass, hardware and enclosure style for your bathroom and budget.',
    icon: Home
  }, {
    title: 'Bathroom Remodelers & Designers',
    copy: 'Coordinate shower glass options, final measurements and installation details for a polished finished bathroom.',
    icon: PenTool
  }, {
    title: 'Builders & Contractors',
    copy: "Bring Kosin's Glass into the process for custom shower glass on new homes, remodels, additions and renovation projects.",
    icon: HardHat
  }];
  return <section className="py-20 bg-navy text-white" data-id="element-1464">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1465">
        <div className="text-center max-w-3xl mx-auto mb-16 anim-on-scroll" data-id="element-1466">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 tracking-tight" data-id="element-1467">
            For Homeowners, Bathroom Remodelers, Designers & Builders
          </h2>
          <p className="text-lg text-blue-100" data-id="element-1468">
            Kosin's Glass works with homeowners planning bathroom upgrades as
            well as remodelers, designers, builders and contractors who need
            custom shower glass measured, fabricated and installed correctly.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-1469">
          {audiences.map((aud, i) => <div key={i} className="bg-navy-800 p-8 rounded-2xl border border-navy-700 scroll-fade-up" style={{
          animationDelay: `${i * 0.1}s`
        }} data-id="element-1470">
              <aud.icon className="w-10 h-10 text-primary mb-6" data-id="element-1471" />
              <h3 className="text-xl font-bold mb-3" data-id="element-1472">{aud.title}</h3>
              <p className="text-blue-100 leading-relaxed" data-id="element-1473">{aud.copy}</p>
            </div>)}
        </div>
        <div className="text-center anim-on-scroll" data-id="element-1474">
          <a href="#quote-form" className="inline-flex items-center justify-center bg-primary hover:bg-primary-hover text-white font-semibold py-4 px-8 rounded-xl transition-colors" data-id="element-1475">
            Talk to a Shower Glass Specialist
          </a>
        </div>
      </div>
    </section>;
}